<div id="side-hovedområde" class="hb-container hb-container--width-sm" data-e2e-selector="veiledning">
    <button hb-button
            [variant]="'LINK'"
            [iconId]="'arrow-left-1'"
            [size]="'SMALL'"
            (click)="navigateBack()"
            translate>
        Tilbake til innsending
    </button>

    <div class="hb-mt--2xl">
        <h1 role="heading" aria-level="1" class="hb-h1 hb-text--2xl" translate>Tips til hvordan du laster opp filer</h1>
        <p class="hb-text--ingress hb-mb--xl" translate>Det finnes ulike måter å få lastet opp filer på, avhengig av om
            det du skal sende inn er lagret som en fil eller på papir.</p>
    </div>

    <div class="hb-mt--xl">
        <h2 class="hb-h2 hb-text--lg" id="last-opp-soknadsskjema" translate>Fyll ut et skjema som er en PDF-fil</h2>
        <p>
            <span translate>Bruk Adobe Acrobat Reader til å fylle ut PDF-skjemaet. Lagre filen. Finn filen på maskinen din og last den opp. </span>
            <span translate>Har du ikke installert Adobe Acrobat Reader, kan du
                <a href="https://get.adobe.com/no/reader/"
                   target="_blank" class="hb-interactive"
                   translate>
                    <span class="hb-button-text" translate>laste ned programmet her (åpnes i nytt vindu)</span>
                    <hb-icon class="hb-mb--xs hb-ml--xs" size="Size100" iconId="expand-6"></hb-icon>
                </a>
            </span>
        </p>
        <p translate>Finner du ikke lagre-knappen i Acrobat Reader? Trykk F9. Da får du tilbake verktøylinjen.</p>
    </div>

    <div class="hb-mt--xl">
        <h2 class="hb-h2 hb-text--lg" id="last-opp-digital" translate>Hvordan laste opp vedlegg du har digitalt</h2>
        <p translate>Hvis du har vedlegg digitalt som du ikke får til å laste opp, kan det hende at den er i en filtype
            vi ikke støtter.</p>

        <p translate>Vi støtter disse filtypene:</p>
        <ul class="hb-list">
            @for(myType of filtypeEnum | keyvalue;track myType.key) {
                <li>{{myType.value}}</li>
            }
        </ul>
    </div>

    <div class="hb-mt--xl">
        <h2 class="hb-h2 hb-text--lg" id="last-opp-papir" translate>Hvordan laste opp vedlegg du har på papir</h2>
        <h3 class="hb-h3 hb-text--base" translate>Ta bilde</h3>

        <div class="hb-mt--lg">
            <p translate>Bruk smarttelefonen eller nettbrettet ditt. Pass på dette når du tar bilde:</p>
            <ol class="hb-list">
                <li translate>Legg dokumentet flatt.</li>
                <li translate>Sørg for å ha godt lys.</li>
                <li translate>Sørg for at bildet blir klart og at dokumentet kan leses.</li>
            </ol>
        </div>

        <div class="hb-mt--xl">
            <p translate>For å laste opp bildet, må du velge ett av disse stegene:</p>
            <ol class="hb-list">
                <li translate>Logg inn via mobilen eller nettbrettet du tok bilde med og legg ved bildet som vedlegg.
                </li>
                <li translate>Eller send bildet til din egen e-post. Deretter kan du lagre det og laste det opp fra
                    datamaskinen du fyller ut skjemaet på.
                </li>
            </ol>
        </div>

        <div>
            <h3 class="hb-h3 hb-text--base" translate>Skann</h3>
            <p translate>Hvis du har en skanner hjemme, kan du skanne dokumentet og lagre filen et sted du finner den
                igjen.</p>
            <p translate>Hvis du bruker en skanner på et bibliotek eller et annet offentlig kontor, send det skannede
                dokumentet til e-postadressen din.</p>
        </div>
    </div>

    <button hb-button
            [variant]="'LINK'"
            [iconId]="'arrow-left-1'"
            [size]="'SMALL'"
            (click)="navigateBack()" translate>
        Tilbake til innsending
    </button>
</div>
